import { application } from "./application"

import CarouselController from "./carousel_controller"
import ServicesController from "./services_controller"
import ReadMoreController from "./read_more_controller"
import FaqItemController from "./faq_item_controller"

application.register("carousel", CarouselController)
application.register("services", ServicesController)
application.register("read-more", ReadMoreController)
application.register("faq-item", FaqItemController)
